import React from "react";

const Loading = () =>{
    return(
        <>
           <h2 className='text-loading text-center mx-auto display-2 py-5 my-5'>Loading...</h2>

        </>

    );
}

export default Loading;